import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

const Sidebar = () => {
  const location = useLocation(); // Get the current location
  const [role, setRole] = useState(null);
  const [volunteerStatus, setVolunteerStatus] = useState(null);
  const [userRole, setUserRole] = useState("");

  const { state } = useAppContext();

  const handleToggleSidebar = () => {
    // Your toggle sidebar logic here
    window.clickToggleSidebarIcon();
    console.log("Sidebar toggled!");
  };

  // useEffect(() => {
  //   const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
  //   const is_volunteer = JSON.parse(localStorage.getItem("is_volunteer")); // Parses string "admin" to plain string

  //   setRole(role);
  //   setVolunteerStatus(is_volunteer);
  // }, []);

  // console.log("Role",state?.user?.role)
  // console.log("Volunteer status",state?.user?.is_volunteer)

  useEffect(() => {
    setUserRole(state?.user?.role);
    setVolunteerStatus(state?.user?.is_volunteer);
  }, []);

  return (
    <div className="sidebar " id="main-sidebar" data-background-color="dark">
      <div className="sidebar-logo">
        <div className="logo-header" data-background-color="dark">
          <Link to="/dashboard" className="logo">
            <img
              src="/icon/sidebar-icon-white.jpeg"
              alt="navbar brand"
              className="navbar-brand rounded-image"
              loading="lazy"
              height="60"
            />
          </Link>
          <div
            className="nav-toggle cursor-pointer "
            onClick={handleToggleSidebar}
          >
            <button className="btn btn-toggle toggle-sidebar">
              <i className="gg-menu-right"></i>
            </button>
            <button className="btn btn-toggle sidenav-toggler">
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
      </div>
      <div className="sidebar-wrapper position-relative scrollbar scrollbar-inner">
        <div className="sidebar-content">
          <ul className="nav nav-secondary">
            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/dashboard" ? "active" : ""
                }`}
              >
                <Link to="/user/dashboard">
                  <i className="fas fa-home"></i>
                  <p>Dashboard</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/users" ? "active" : ""
                }`}
              >
                <Link to="/user/users">
                  <i className="fas fa-user"></i>
                  <p>Users</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/donor" ? "active" : ""
                }`}
              >
                <Link to="/donor">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Donors</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/leads" ? "active" : ""
                }`}
              >
                <Link to="/user/leads">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Leads</p>
                </Link>
              </li>
            )}

            {/* Add Donor Group tab */}
            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/donor/group" ? "active" : ""
                }`}
              >
                <Link to="/donor/group">
                  <i className="fas fa-users"></i>
                  {/* <p>Students</p> */}
                  <p>Donor Groups</p>
                </Link>
              </li>
            )}
            {/* Add Conversation  tab */}
            <li
              className={`nav-item ${
                location.pathname === "/donor/conversation" ? "active" : ""
              }`}
            >
              <Link to="/donor/conversation">
                {/* <i className="fas fa-users"></i> */}
                <i className="fas fa-comment-dots"></i>

                {/* <p>Students</p> */}
                <p>Conversations</p>
              </Link>
            </li>

            {/* Add Gift  tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/gifts" ? "active" : ""
              }`}
            >
              <Link to="/user/gifts">
                {/* <i className="fas fa-users"></i> */}
                <i className="fas fa-gift"></i>

                {/* <p>Students</p> */}
                <p>Gifts</p>
              </Link>
            </li>

            <li
              className={`nav-item ${
                location.pathname === "/user/events" ? "active" : ""
              }`}
            >
              <Link to="/user/events">
                <i className="fas fa-calendar-alt"></i>
                <p>Events</p>
              </Link>
            </li>

            {/* Add Gift Distribution tab */}
            {(userRole === "admin" || volunteerStatus === "yes") && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/gifts/distribution"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/user/gifts/distribution">
                  <i className="fas fa-gift"></i>
                  <p>Gifts Distribution</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/daily-quotes" ? "active" : ""
                }`}
              >
                <Link to="/user/daily-quotes">
                  <i className="fas fa-quote-left"></i>
                  <p>Daily Quotes</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/daily-darshan" ? "active" : ""
                }`}
              >
                <Link to="/user/daily-darshan">
                  <i className="fas fa-sun"></i>
                  <p>Daily Darshan</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/temple-program-schedule"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/user/temple-program-schedule">
                  <i className="fas fa-calendar-alt"></i>
                  <p>Temple Program Schedule</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/daily-registrations"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/user/daily-registrations">
                  <i className="fas fa-clipboard-list"></i>
                  <p>Daily Registrations</p>
                </Link>
              </li>
            )}

            {/* Add Sbi Donation  tab */}
            <li
              className={`nav-item ${
                location.pathname === "/donations" ||
                location.pathname === "/user/manual-recurring-donation-summary"
                  ? "active"
                  : ""
              }`}
            >
              <Link to="/donations">
                {/* <i className="fas fa-users"></i> */}
                <i className="fas fa-hands-helping"></i>

                {/* <p>Students</p> */}
                <p>Manual Donations</p>
              </Link>
            </li>

            {/* Add recurring Donation  tab */}
            <li
              className={`nav-item ${
                location.pathname === "/recurring/donations" ? "active" : ""
              }`}
            >
              <Link to="/recurring/donations">
                {/* <i className="fas fa-users"></i> */}
                <i className="fas fa-sync-alt"></i>

                {/* <p>Students</p> */}
                <p>Auto Recurring Donations</p>
              </Link>
            </li>

            {/* PhonePe Transactions tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/phonepe-transactions" ? "active" : ""
              }`}
            >
              <Link to="/user/phonepe-transactions">
                <i className="fas fa-receipt"></i>
                <p>PhonePe Transactions</p>
              </Link>
            </li>

            {/* Add Manual Recurring Donation  tab */}
            {/* <li
              className={`nav-item ${
                location.pathname === "/user/manual-recurring-donation"
                  ? "active"
                  : ""
              }`}
            >
              <Link to="/user/manual-recurring-donation">
                <i className="fas fa-hands-helping"></i>

                <p>Manual Recurring Donation</p>
              </Link>
            </li> */}

            <li
              className={`nav-item ${
                location.pathname === "/user/aarti" ? "active" : ""
              }`}
            >
              <Link to="/user/aarti">
                <i className="fas fa-fire"></i>
                <p>Folk Aarti</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/user/courses" ? "active" : ""
              }`}
            >
              <Link to="/user/courses">
                <i className="fas fa-graduation-cap"></i>
                <p>Courses Settings</p>
              </Link>
            </li>

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/upload/history" ? "active" : ""
                }`}
              >
                <Link to="/upload/history">
                  <i className="fas fa-history"></i>
                  <p>Upload History</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/tr-manager" ? "active" : ""
                }`}
              >
                <Link to="/tr-manager">
                  <i className="fas fa-history"></i>
                  <p>TR Number Manager</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/joined" ? "active" : ""
                }`}
              >
                <Link to="/user/joined">
                  <i className="fas fa-user"></i>
                  <p>Joined Donors</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/master" ? "active" : ""
                }`}
              >
                <Link to="/user/master">
                  <i className="fas fa-user"></i>
                  <p>Master</p>
                </Link>
              </li>
            )}

            <li
              className={`nav-item ${
                location.pathname === "/user/account-settings" ? "active" : ""
              }`}
            >
              <Link to="/user/account-settings">
                <i className="fas fa-cog"></i>
                <p>Account Settings</p>
              </Link>
            </li>

            <li
              className={`nav-item ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              <Link to="/logout">
                <i className="fas fa-sign-out-alt"></i>
                <p>Logout</p>
              </Link>
            </li>
          </ul>

          <li
            className={`nav-item mt-4 ${
              location.pathname === "/" ? "active" : ""
            }`}
          >
            <a
              href="https://whatsapp.com/channel/0029Va5zbhvEAKWNQ5qf1r0e "
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <button
                style={{
                  backgroundColor: "#25D366",
                  color: "white",
                  padding: "10px 15px",
                  border: "none",
                  borderRadius: "30px",
                  cursor: "pointer",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  marginLeft: "20px",
                  // marginRight:"10px"
                  // marginTop:"20px"
                }}
              >
                <i className="fab fa-whatsapp" style={{ fontSize: "2rem" }}></i>
                <span>Join whatsapp</span>
              </button>
            </a>
          </li>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
